export const AGGREGATES = ['volume', 'impressions', 'reachEstimate'];
